export const ALCHEMY_API_KEY = 'jxUUn2DsYODlc68SEU_7eNGCn2hQ7b63';
export const CHAIN = 'MAINNET';
